export default __webpack_public_path__ + "static/media/logo.d608cf93.jpg";